import { render, staticRenderFns } from "./ProductsTableName.vue?vue&type=template&id=006b748b&"
import script from "./ProductsTableName.vue?vue&type=script&lang=js&"
export * from "./ProductsTableName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports